<template>
  <CustomModal
    id="demo-video-required-modal"
    modalClass="custom-modal_margin-custom custom-modal_delete-modal demo-video-required-modal"
  >
    <template #header>
      <BaseHeading
        level="2"
        weight="500"
      >
        Demo Video Required
      </BaseHeading>
    </template>

    <template #body>
      <BaseSubHeading
        size="medium"
        weight="400"
        class="demo-video-required-modal__body"
      >
        Please upload a demo or provide a demo video link to mark this Definition of Done item
        completed.
      </BaseSubHeading>
    </template>

    <template #footer="{ hide }">
      <ControlButtons
        @save="onConfirm(hide)"
        @cancel="hide"
      >
        <template #save> Ok </template>
        <template #cancel> Cancel </template>
      </ControlButtons>
    </template>
  </CustomModal>
</template>

<script setup lang="ts">
import ControlButtons from "@/components/ControlButtons/index.vue"
import CustomModal from "@/components/Modal/index.vue"

const emit = defineEmits<{ (e: "confirm"): void }>()

const onConfirm = (hide: () => void) => {
  hide()
  emit("confirm")
}
</script>
